(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('DateService', ['$rootScope', '$state', '$filter', '$stateParams', 'AdministrationService', 'SharedAgendaService', 'CalendarBroadcast', 'DayschemeService', DateServiceFn]);

    // global date service 
    function DateServiceFn($rootScope, $state, $filter, $stateParams, AdministrationService, SharedAgendaService, CalendarBroadcast, DayschemeService) {
        // data
        var data = {
            date: null, // current selected date,
            info: {}, // information about date (week-number, first-day-of-week, last-day-of-week)
            specials: [] // list of special days -> extra-days and global holidays
        };

        var service = {
            data: data
        };

        service.getDate = () => data.date;

        // set new date
        service.date = function (date) {
            data.info = {};
            data.date = date;
            return AdministrationService.informationAboutDate(date.toJSON(), SharedAgendaService.data.currentAgenda.weekStartDay).then(function (result) {
                data.info = result;
            });
        };
        
        service.getDateCaption = () => $filter('RfGlobalLongDateFilter')(data.date);

        // is selected date TODAY ?
        service.isToday = function () {
            if (data.date === null) { return false; }
            return moment(data.date).isSame(moment(), "day");
        };

        // select today
        service.today = function () {
            service.date(new Date());
            $rootScope.$broadcast(CalendarBroadcast.SelectDate, data.date);
        };

        // Is Date Between Current Week
        service.isInWeek = function (date) {
            return moment(date).isBetween(service.data.info.firstDayOfWeek, service.data.info.lastDayOfWeek);
        };

        // Same Date
        service.isSameDay = function (date1, date2) {
            return moment(date1).isSame(date2, "day");
        };

        // set new date and update ui
        service.dateAndReload = function (date) {
            return service.date(date).then(function () {
                // reload current state (just child state)
                $state.go($state.current, $stateParams, { reload: $state.current });
                // inform 
                $rootScope.$broadcast(CalendarBroadcast.SelectDate, data.date);                
            });
        }; // dateAndReload       

        // set new date and broadcast change
        service.dateAndBroadcast = function (date) {
            return service.date(date).then(function () {
                // inform 
                $rootScope.$broadcast(CalendarBroadcast.SelectDate, data.date);
                return;
            });
        };

        // next day
        service.next = function (number) {
            if (!number)
            {
                number = 1;
            }
            return moment(data.date).add(number, 'days').toDate();
        };

        // previous day
        service.previous = function (number) {
            if (!number)
            {
                number = 1;
            }
            return moment(data.date).add(-1*number, 'days').toDate();
        };

        // next week
        service.nextWeek = function (number) {
            if (!number)
            {
                number = 1;
            }
            return moment(data.date).add(7*number, 'days').toDate();
        };

        // previous week
        service.previousWeek = function (number) {
            if (!number)
            {
                number = 1;
            }
            return moment(data.date).add(-7*number, 'days').toDate();
        };

        // load extra-days and holidays
        service.extraDaysAndHolidays = function () {
            return DayschemeService.special(SharedAgendaService.currentUser().id).then(function (result) {
                // clean
                data.specials = [];

                // do we have any ?
                if (result === null || result.length <= 0) {
                    return;
                }

                // push to list
                var i = 0;
                var len = result.length;
                for (i = 0; i < len; i++) {
                    var dateObj = result[i];
                    //setup event list - set styles for events
                    service.addExtraDay(dateObj);
                } // for

                return;

            });
        };

        // add extra day to list
        service.addExtraDay = function (dateObj) {

            var status = 'global_holiday'; // default            
            if (dateObj.isExtraHoliday) { status = 'extra_holiday'; }
            else if (dateObj.schoolHoliday) {status = 'shool_holiday'; }
            
            //setup event list - set styles for events
            data.specials.push({
                dateObj: dateObj,
                date: dateObj.date,
                status: status
            });
        };

        // component function so set a depending class for a day
        service.getDependingClass = function (dataObj) {
            if (data.specials === undefined) { return ''; }
            //check for day mode
            if (dataObj.mode === 'day') {
                var dayToCheck = new Date(dataObj.date).setHours(0, 0, 0, 0);

                var i = 0;
                var len = data.specials.length;
                for (i = 0; i < len; i++) {
                    var currentDay = new Date(data.specials[i].date).setHours(0, 0, 0, 0);

                    // if day is a eventday
                    if (dayToCheck === currentDay) {
                        return data.specials[i].status;
                    }
                }
            }

            return '';
        };

        // find depending date text
        service.getDependingDateText = function (date) {
            var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

            // search in events
            var i = 0;
            var len = data.specials.length;
            for (i = 0; i < len; i++) {
                var currentDay = new Date(data.specials[i].date).setHours(0, 0, 0, 0);

                // if day is a eventday
                if (dayToCheck === currentDay) {
                    var dateObj = data.specials[i].dateObj;

                    return dateObj.description ? String(dateObj.description).replace(/<[^>]+>/gm, '') : '';
                }
            }
            return "";
        };



        return service;

    }
})();